// 切り出す板のサイズ入力コンポーネント

// React 18以降はJSXの自動変換によりReactインポートは不要

interface PieceInputProps {
  width: string;
  height: string;
  onWidthChange: (value: string) => void;
  onHeightChange: (value: string) => void;
  widthError?: string;
  heightError?: string;
  widthTouched?: boolean;
  heightTouched?: boolean;
}

export function PieceInput({
  width,
  height,
  onWidthChange,
  onHeightChange,
  widthError,
  heightError,
  widthTouched,
  heightTouched,
}: PieceInputProps) {
  const showWidthError = widthError && widthTouched;
  const showHeightError = heightError && heightTouched;

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-700">切り出す板のサイズ</h3>
      
      <div className="grid grid-cols-2 gap-4">
        <div className="form-group">
          <label htmlFor="piece-width" className="form-label">
            幅 (mm)
            <span className="text-red-600 ml-1" aria-label="必須">*</span>
          </label>
          
          <input
            type="number"
            id="piece-width"
            value={width}
            onChange={(e) => onWidthChange(e.target.value)}
            className={`input-field ${showWidthError ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''}`}
            placeholder="300"
            min="1"
            step="1"
            aria-invalid={showWidthError ? 'true' : 'false'}
            aria-describedby={showWidthError ? 'piece-width-error' : undefined}
          />

          {showWidthError && (
            <div id="piece-width-error" className="form-error" role="alert">
              {widthError}
            </div>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="piece-height" className="form-label">
            高さ (mm)
            <span className="text-red-600 ml-1" aria-label="必須">*</span>
          </label>
          
          <input
            type="number"
            id="piece-height"
            value={height}
            onChange={(e) => onHeightChange(e.target.value)}
            className={`input-field ${showHeightError ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''}`}
            placeholder="200"
            min="1"
            step="1"
            aria-invalid={showHeightError ? 'true' : 'false'}
            aria-describedby={showHeightError ? 'piece-height-error' : undefined}
          />

          {showHeightError && (
            <div id="piece-height-error" className="form-error" role="alert">
              {heightError}
            </div>
          )}
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-blue-600 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <h4 className="text-sm font-semibold text-blue-800">切り出し条件について</h4>
            <p className="mt-1 text-sm text-blue-700">
              計算では、どちらの板材からより多くの板を取れるかを自動判定します。
              同数の場合は、余り面積が少ない方を選択します。
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}